import { render, staticRenderFns } from "./RobotSend.vue?vue&type=template&id=74452bde&scoped=true"
import script from "./RobotSend.vue?vue&type=script&lang=js"
export * from "./RobotSend.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74452bde",
  null
  
)

export default component.exports